// extracted by mini-css-extract-plugin
export default {"mainCont":"PaymentSuccess_mainCont__P49Oy"};